import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default {
  exact: true,
  path: '/home/content/moments',
  owner: '/home',
  // authority: 'Vclist',
  component: Loadable({
    loader: () => import('./index'),
    loading: () => <RouteLoading />
  })
};